<div class="liability-payment-transferred-tooltip-wrapper status error flex flex-col justify-start">
    <span class="flex flex-row items-center justify-start">
          <app-icon name="arrow_right_down" [width]="10" [height]="16"
          matTooltip="Twoja opłata została zaksięgowana na poczet wcześniejszej nieopłaconej faktury od tego samego dostawcy">
          </app-icon>
    </span>
</div>
